export default __webpack_public_path__ + "static/media/Ansh_Goyal.6bd03026.jpg";